import { ReactNode } from "react";

export type ButtonV2Props = {
  children: ReactNode;
  type?: "button" | "submit";
  variant?: "primary" | "secondary" | "ghost";
  disabled?: boolean;
  onClick?: () => void;
};

export function ButtonV2({ children, type = "button", variant = "primary", disabled = false, onClick }: ButtonV2Props) {
  return (
    <button className={`ov2-button ov2-button--${variant}`} type={type} disabled={disabled} onClick={onClick}>
      {children}
    </button>
  );
}
